import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";

export default function AndarBahar50Card() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "ab3";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };

  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      // gameName={"CARDS 32B"}
    >
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="andar-box">
              <div className="ab-title">ANDAR</div>
              <div className="ab-cards">
                {/* {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]?.map((item, index) => (
                  <div
                    className="card-odd-box"
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS[0]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div className="casino-odds">
                      {" "}
                      {getOddForEntity(
                        casinoData?.data?.response?.oddDetailsDTOS[0]
                          ?.runnerName,
                        casinoData,
                        false
                      )}
                    </div>
                    <div>
                      {getOddForEntity(
                        `Andar ${
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        }`,
                        casinoData,
                        true,
                        false,
                        true
                      ) == "SUSPENDED" &&
                      !baharCardsList?.includes(
                        String(
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        )
                      ) ? (
                        <img
                          src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${0}.jpg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${index +1}.jpg`}
                          alt=""
                        />
                      )}
                    </div>
                    <div className="casino-nation-book">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        `Andar ${
                          item == 11
                            ? "J"
                            : item == 12
                            ? "Q"
                            : item == 13
                            ? "K"
                            : item
                        }`
                      )}
                      
                    </div>
                  </div>
                ))} */}
                {/* <div
                  className={`card-odd-box  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet(
                      casinoData?.data?.response?.oddDetailsDTOS[0]?.runnerName,
                      casinoData,
                      dispatch,
                      "back"
                    )
                  }
                >
                  <div className="casino-odds">
                    {" "}
                    {getOddForEntity(
                      casinoData?.data?.response?.oddDetailsDTOS[0]?.runnerName,
                      casinoData,
                      false
                    )}
                  </div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/1.jpg" 
                    alt=""/>
                  </div>
                  <div className="casino-nation-book">
                    <span className="text-danger">
                      {" "}
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        casinoData?.data?.response?.oddDetailsDTOS[0]
                          ?.runnerName
                      )}
                    </span>
                  </div>
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/2.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/3.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">4</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/4.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/5.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/7.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/8.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/11.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/13.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div> */}
                {casinoData?.data?.response?.oddDetailsDTOS
                  ?.slice(1, 13)
                  .map((card, index) => {
                    const isSuspended =
                      casinoData?.data?.response?.autoTime < 5;
                    const runnerName = card?.runnerName;
                    const cardImageIndex = card?.cardNumber || index + 1;

                    return (
                      <div
                        key={index}
                        className={`card-odd-box ${
                          isSuspended ? "suspended-box" : ""
                        }`}
                        onClick={() =>
                          setBet(runnerName, casinoData, dispatch, "back")
                        }
                      >
                        <div className="casino-odds">
                          {getOddForEntity(runnerName, casinoData, false)}
                        </div>
                        <div>
                          <img
                            src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${cardImageIndex}.jpg`}
                            alt={`card-${cardImageIndex}`}
                          />
                        </div>
                        <div className="casino-nation-book">
                          <span className="text-danger">
                            {getCasinoPlExposureByRunner(
                              casinoPlData,
                              runnerName
                            )}
                          </span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="bahar-box">
              <div className="ab-title">BAHAR</div>
              <div className="ab-cards">
                {casinoData?.data?.response?.oddDetailsDTOS
                  ?.slice(14, 26)
                  .map((card, index) => {
                    const isSuspended =
                      casinoData?.data?.response?.autoTime < 5;
                    const runnerName = card?.runnerName;
                    const cardImageIndex = card?.cardNumber || index + 1;

                    return (
                      <div
                        key={index}
                        className={`card-odd-box ${
                          isSuspended ? "suspended-box" : ""
                        }`}
                        onClick={() =>
                          setBet(runnerName, casinoData, dispatch, "back")
                        }
                      >
                        <div className="casino-odds">
                          {getOddForEntity(runnerName, casinoData, false)}
                        </div>
                        <div>
                          <img
                            src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/${cardImageIndex}.jpg`}
                            alt={`card-${cardImageIndex}`}
                          />
                        </div>
                        <div className="casino-nation-book">
                          <span className="text-danger">
                            {getCasinoPlExposureByRunner(
                              casinoPlData,
                              runnerName
                            )}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                {/* <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/1.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/2.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/3.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">4</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/4.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/5.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">2</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/7.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/8.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/11.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">0</div>
                  <div className="">
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/0.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div>
                <div className="card-odd-box">
                  <div className="casino-odds">1</div>
                  <div>
                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/andar-bahar-cards/13.jpg" />
                  </div>
                  <div className="casino-nation-book" />
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/ab3">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
